import React, { useState } from 'react'



const LifeInsuranceForm = () => {
    const [gender, setGender] = useState("DEFAULT");
    return (
        <form>
            {/* x---------------------------------x Personal Details x---------------------------------x */}
            <div className="card">
                <div className="card-header p-2">
                    <h4 className="text-dark fs-5 fw-semibold">Personal Details</h4>
                </div>
                <div className="card-body p-2">
                    <div className="row g-2">
                        <div className="col-md-6">
                            <label htmlFor="firstName" className="form-label">First
                                Name</label>
                            <input type="text" className="form-control form-control-lg"
                                id="firstName" required />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="lastName" className="form-label">Last
                                Name</label>
                            <input type="text" className="form-control form-control-lg"
                                id="lastName" required />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="dob" className="form-label">Date of
                                Birth</label>
                            <input type="date" className="form-control form-control-lg"
                                id="dob" required />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="gender" className="form-label">Gender</label>
                            <select
                                className="form-select form-control-lg"
                                id="gender"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                                required
                            >
                                <option value="DEFAULT" disabled>
                                    Select Gender
                                </option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="address" className="form-label">Address</label>
                            <textarea className="form-control" id="address" rows="3"
                                required></textarea>
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Insurance Details x---------------------------------x */}
            <div className="card">
                <div className="card-header p-2">
                    <h4 className="text-dark fs-5 fw-semibold">Insurance Details</h4>
                </div>
                <div className="card-body p-2">
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <label htmlFor="policyType" className="form-label">Policy Type</label>
                            <select
                                className="form-select form-control-lg"
                                id="policyType"
                                defaultValue=""
                                required
                            >
                                <option value="" disabled>
                                    Select Policy Type
                                </option>
                                <option value="term">Term Life Insurance</option>
                                <option value="whole">Whole Life Insurance</option>
                                <option value="universal">Universal Life Insurance</option>
                            </select>
                        </div>

                        <div className="col-md-6 mb-2">
                            <label htmlFor="coverageAmount" className="form-label">Coverage
                                Amount</label>
                            <input type="number"
                                className="form-control form-control-lg"
                                id="coverageAmount" required />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label htmlFor="beneficiaryName"
                                className="form-label">Beneficiary
                                Name</label>
                            <input type="text" className="form-control form-control-lg"
                                id="beneficiaryName" required />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label htmlFor="beneficiaryRelation"
                                className="form-label">Relationship to
                                Beneficiary</label>
                            <input type="text" className="form-control form-control-lg"
                                id="beneficiaryRelation" required />
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Contact Information x---------------------------------x */}
            <div className="card">
                <div className="card-header p-2">
                    <h4 className="text-dark fs-5 fw-semibold">Contact Information</h4>
                </div>
                <div className="card-body p-2">
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <label htmlFor="email" className="form-label">Email
                                Address</label>
                            <input type="email"
                                className="form-control form-control-lg" id="email"
                                required />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label htmlFor="phone" className="form-label">Phone
                                Number</label>
                            <input type="tel" className="form-control form-control-lg"
                                id="phone" required />
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Submit Button x---------------------------------x */}
            <div className="text-end p-2">
                <button type="submit" className="btn btn-primary">Submit
                    Application</button>
            </div>
        </form>
    )
}

export default LifeInsuranceForm